import React from 'react';

// Helper funktion til at parse links i teksten
const parseLinks = (text, subdomain) => {
  // Matches [link text](url)
  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
  
  // Split tekst ved links og konverter til JSX
  const parts = text.split(linkRegex);
  
  return parts.map((part, i) => {
    if (i % 3 === 1) {
      // Link tekst
      const linkText = part;
      let url = parts[i + 1];

      // Hvis det er et internt link (starter med /)
      if (url.startsWith('/')) {
        const hostname = window.location.hostname;
        const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
        
        if (isLocalhost) {
          // På localhost, brug CVR nummer routing
          const pathParts = window.location.pathname.split('/');
          const cvr = pathParts[1];
          url = `/${cvr}${url}`;
        } else if (!subdomain) {
          // På produktion uden subdomain, brug CVR nummer routing
          const pathParts = window.location.pathname.split('/');
          const cvr = pathParts[1];
          url = `/${cvr}${url}`;
        }
        // If subdomain is true, keep the original url
      }

      return (
        <a 
          key={i}
          href={url}
          className="text-blue-600 hover:text-blue-800 hover:underline"
        >
          {linkText}
        </a>
      );
    } else if (i % 3 === 0) {
      // Normal tekst
      return part;
    }
    // Skip URL parts
    return null;
  });
};

const TextLayout = ({ content, subdomain }) => (
    <div className="">
        <h1 className="text-4xl font-bold font-montserrat text-gray-900 mb-4">
            {content.hero?.title}
        </h1>
        {content.hero?.subtitle && (
            <p className="text-xl text-gray-600 mb-8">
                {content.hero?.subtitle}
            </p>
        )}
        {content.main?.content && content.main.content.split('\n\n').map((paragraph, index) => (
            <p key={index} className="text-gray-700 mb-6 leading-relaxed">
                {parseLinks(paragraph, subdomain)}
            </p>
        ))}
    </div>
);

export default TextLayout;